var $a39519a04d4a70c7$exports = {};
$a39519a04d4a70c7$exports = {
    "alert": `Advarsel`,
    "dismiss": `Luk`
};


export {$a39519a04d4a70c7$exports as default};
//# sourceMappingURL=da-DK.mjs.map
